export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-24-f21eaabb262d429ee933dcc6d41090a9.jpg";